
// fonts optimization
(function () {
    const preloadLinks = [
        //'https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap',
    ];

    preloadLinks.forEach(href => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = href.includes('fonts.googleapis.com') ? 'style' : 'font';
        link.href = href;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
    });
})();

// performance optimization
(function () {
    if ('PerformanceObserver' in window) {
        const observer = new PerformanceObserver((list) => {
            const entries = list.getEntries();
        });
        try {
            observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input'] });
        } catch (e) { }
    }
})();

// image lazy loading
(function () {
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.classList.add('loaded');
                    }
                    imageObserver.unobserve(img);
                }
            });
        });

        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('img.lazy').forEach(img => imageObserver.observe(img));
        });
    }
})();

// low connection checker
(function () {
    if ('connection' in navigator && navigator.connection) {
        const connection = navigator.connection;
        const connectionType = connection.effectiveType || 'unknown';
        window.__networkInfo = {
            type: connectionType,
            downlink: connection.downlink,
            rtt: connection.rtt
        };
    }
})();

// service worker check
(function () {
    if ('serviceWorker' in navigator && location.hostname !== 'localhost') {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            if (registrations.length === 0) {
                console.debug('[SW] Service Worker not registered');
            }
        }).catch(() => { });
    }
})();

// goal tracking → собственная БД (дублируем reachGoal Метрики, чтобы конверсии
// оставались у нас даже если Метрика недоступна). Перехватываем window.ym ДО
// инициализации Метрики, сохраняя её очередь вызовов.
(function () {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    if (window.__goalTrapInstalled) {
        return;
    }

    function getCookie(name) {
        var m = document.cookie.match('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)');
        return m ? decodeURIComponent(m[1]) : null;
    }

    // ym_uid приходит из getClientID (см. ниже), кэшируем
    var ymUid = null;
    window.addEventListener('yandex_metrika_loaded', function (e) {
        if (e && e.detail && e.detail.ymUid) ymUid = e.detail.ymUid;
    });

    // Антидубль: один и тот же goal с одной страницы за 2с пишем один раз
    // (на случай если сработают и обёртка ym, и явный вызов window.goal).
    var _recentGoals = {};

    function recordGoal(name) {
        try {
            var key = name + '|' + location.pathname;
            var ts = Date.now();
            if (_recentGoals[key] && (ts - _recentGoals[key]) < 2000) return;
            _recentGoals[key] = ts;

            var payload = JSON.stringify({
                goal: name,
                visit_uuid: getCookie('visit_uuid'),
                url: location.pathname,
                ym_uid: ymUid || getCookie('_ym_uid'),
            });
            if (navigator.sendBeacon) {
                navigator.sendBeacon('/events/goal', new Blob([payload], { type: 'application/json' }));
            } else {
                fetch('/events/goal', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: payload,
                    keepalive: true,
                }).catch(function () {});
            }
        } catch (err) { /* аналитика не должна ломать страницу */ }
    }

    // Надёжная фиксация цели: явно шлём и в Метрику, и в свою БД.
    // НЕ зависит от подмены window.ym (которую перетирает tag.js Метрики) —
    // beacon уходит всегда. Использовать вместо прямых ym(...,'reachGoal',...).
    window.goal = function (name) {
        try {
            if (typeof window.ym === 'function') window.ym(24900584, 'reachGoal', name);
        } catch (e) { /* noop */ }
        recordGoal(name);
    };

    function wrap(fn) {
        if (typeof fn !== 'function' || fn.__goalWrapped) return fn;
        function wrapped() {
            var a = arguments;
            if (a[1] === 'reachGoal' && a[2]) {
                try { recordGoal(a[2]); } catch (e) {}
            }
            return fn.apply(this, a);
        }
        // переносим служебные свойства очереди Метрики (a — массив вызовов, l — таймстамп)
        wrapped.a = fn.a;
        wrapped.l = fn.l;
        wrapped.__goalWrapped = true;
        return wrapped;
    }

    var _ym = window.ym ? wrap(window.ym) : undefined;
    try {
        Object.defineProperty(window, 'ym', {
            configurable: true,
            get: function () { return _ym; },
            set: function (v) {
                var w = wrap(v);
                // сохраняем очередь, если её ещё нет на новом значении
                if (w && _ym && w.a == null) w.a = _ym.a;
                _ym = w;
            },
        });
        window.__goalTrapInstalled = true;
    } catch (e) {
        // фолбэк: если defineProperty недоступен — простая обёртка
        if (window.ym) window.ym = _ym;
    }
})();

// developer debugger
(function() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    if (window.__metrikaLoaded) {
        return;
    }
    
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.textContent = `
        (function(m, e, t, r, i, k, a) {
            m[i] = m[i] || function() {
                (m[i].a = m[i].a || []).push(arguments)
            };
            m[i].l = 1 * new Date();
            for (var j = 0; j < document.scripts.length; j++) {
                if (document.scripts[j].src === r) return;
            }
            k = e.createElement(t), a = e.getElementsByTagName(t)[0];
            k.async = 1;
            k.src = r;
            a.parentNode.insertBefore(k, a)
        })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(24900584, "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
            trackHash: true
        });
        
        ym(24900584, 'getClientID', function(uid) {
            window.dispatchEvent(new CustomEvent('yandex_metrika_loaded', {
                detail: { ymUid: uid }
            }));
        });
        
        window.__metrikaLoaded = true;
    `;
    
    document.head.appendChild(script);
})();
